document.addEventListener('alpine:init', () => {
    Alpine.store('http', {
        headers: {
            'Content-Type': 'application/json',
            'Lang': window.lang,
            'csrf' : document.querySelector('meta[name=csrf_token]')?.getAttribute('content')
        },
        API_PATH: "/",

        async handleResponse(response, action) {
            if (!response.ok) {
                let errorPayload = null;
                try {
                    errorPayload = await response.json();
                } catch (_) {
                }
                const err = new Error(`${response.status} ${response.statusText}`);
                err.status = response.status;
                err.data = errorPayload;
                throw err;
            }

                const contentType = response.headers.get("content-type");
            if (contentType && contentType.includes("application/json")) {
                const result = await response.json();
                if (result.redirect) {
                    window.open(result.redirect, '_blank');
                    return;
                }
                return result;
            }

            return await response.text();
        },

        async get(action, queryparams = {}) {
            const qs = new URLSearchParams();

            Object.entries(queryparams).forEach(([key, val]) => {
                if (Array.isArray(val)) {
                    val.forEach(v => qs.append(key, v));
                } else {
                    qs.set(key, val);
                }
            });

            const url = `${this.API_PATH}${action}${qs.toString() ? `?${qs.toString()}` : ''}`;

            const response = await fetch(url, {
                method: 'GET',
                headers: this.headers
            });

            return this.handleResponse(response, `GET ${action}`);
        },

        async post(action, data = {}) {
            const response = await fetch(`${this.API_PATH}${action}`, {
                method: 'POST',
                headers: this.headers,
                body: JSON.stringify(data)
            });

            return this.handleResponse(response, `POST ${action}`);
        },

        async put(action, data = {}) {
            const response = await fetch(`${this.API_PATH}${action}`, {
                method: 'PUT',
                headers: this.headers,
                body: JSON.stringify(data)
            });

            return this.handleResponse(response, `PUT ${action}`);
        },

        async delete(action, data = {}) {
            const response = await fetch(`${this.API_PATH}${action}`, {
                method: 'DELETE',
                headers: this.headers,
                body: JSON.stringify(data)
            });

            return this.handleResponse(response, `DELETE ${action}`);
        }
    });
});
